import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12.077 20h-5.077v-16h11v14h-5.077","key":"svg-0"}]]

/**
 * IconBrandPagekit
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtcGFnZWtpdCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTIuMDc3IDIwaC01LjA3N3YtMTZoMTF2MTRoLTUuMDc3IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/brand-pagekit
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandPagekit = createReactComponent('outline', 'brand-pagekit', 'BrandPagekit', __iconNode);

export default IconBrandPagekit;